import React, { useLayoutEffect } from "react"
import PropTypes from "prop-types";
import Immutable from "immutable";
import { connect } from "react-redux";
import { DEFAULT_PAGE_SIZE } from "../../../../config/constants";
import ModuleList from "../../../layout/ModuleList";
import { BUS_CHASSIS_PATH, NEW_BUS_CHASSIS_PATH } from "../../../../config/paths";
import { breadcrumbsPropTypes } from "../../../common/resource/proptypes/CommonPropTypes";
import { BUS_CHASSIS_COLUMN } from "../../../../config/columns";
import { clearBusesChassis, getBusesChassis } from "../../../../actions";

export const BusesChassis = (
    {
  breadcrumbs,
  busesChassis,
  loading,
  dispatchGetBusesChassis,
  dispatchClearBusesChassis,
}
) => {
    useLayoutEffect(()=>()=>dispatchClearBusesChassis(), []);

    const data = busesChassis.get('content') || [];
    const pages = busesChassis.get('totalPages') || null;
    const defaultPageSize = busesChassis.get('size') || DEFAULT_PAGE_SIZE;

    return (
    <ModuleList
        title="Chasís"
        breadcrumbs={breadcrumbs}
        buttonPath={NEW_BUS_CHASSIS_PATH}
        tableStructure={{
        columns: BUS_CHASSIS_COLUMN,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetBusesChassis,
        modelPath: BUS_CHASSIS_PATH,
        loading,
        navigateToModelOnRowClick: true,
        }}
    />
    ); 
}

const mapDispatchToProps = {
  dispatchGetBusesChassis: getBusesChassis,
  dispatchClearBusesChassis: clearBusesChassis,
};

const mapStateToProps = ({ BusUnit }) => ({
  breadcrumbs: [
    ...BusUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Chasís',
      href: BUS_CHASSIS_PATH,
    },
  ],
  busesChassis: BusUnit.BusChassis.getIn(['all', 'content']),
  loading: BusUnit.BusChassis.getIn(['all', 'loading']),
});

BusesChassis.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  busesChassis: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetBusesChassis: PropTypes.func.isRequired,
  dispatchClearBusesChassis: PropTypes.func.isRequired,
};

BusesChassis.defaultProps = {
  busesChassis: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(BusesChassis);